import { ComponentPropsWithoutRef, forwardRef } from 'react'

import { cn } from '@sparkai/utils'

import { Icon } from '../Icon'

export type ConfigureColumnsButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'children'>

export const ConfigureColumnsButton = forwardRef<HTMLButtonElement, ConfigureColumnsButtonProps>(
  function ConfigureColumnsButton({ className, ...props }, ref) {
    return (
      <button
        ref={ref}
        type='button'
        aria-label='Configure columns'
        className={cn(
          'flex h-11 w-11 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none',
          className
        )}
        {...props}
      >
        <Icon name='vector' className='h-4 w-4 text-gray-400' />
      </button>
    )
  }
)
